/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { KartePlannerCommentFormViewerFragmentDoc, KartePlannerCommentFormAvailabilityFragmentDoc } from './KartePlannerCommentForm.generated';
import { KartePlannerCommentMonthlyAmountFragmentDoc } from '../KartePlannerCommentMonthlyAmount/KartePlannerCommentMonthlyAmount.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type KartePlannerCommentUnavailableReason =
  /** 同カルテにカルテコメントを送信済みのためアプローチできない */
  | 'ALREADY_COMMENTED'
  /** すでにマッチしているユーザーのためアプローチできない */
  | 'ALREADY_MATCHED'
  /** プラン開始前(契約期間前)のためアプローチできない */
  | 'BEFORE_CONTRACT_PERIOD'
  /** プランナーがカルテに対応するチャネルを持っていないためアプローチできない */
  | 'CHANNEL_DOES_NOT_MATCH'
  /** 管理者専用無料プランのためコメントできない */
  | 'HAS_MANAGE_ONLY_FREE_PLAN'
  /** PRプランのため、アプローチできない */
  | 'HAS_PR_PLAN'
  /** プランナーの月ごとの送信数上限に達したためアプローチできない */
  | 'REACHED_TO_MONTHLY_LIMIT'
  /** 上記の理由以外においてエラー */
  | 'UNKNOWN';

export type Plan =
  /** V2021_1 エンタープライズプラン */
  | 'V2021_1Enterprise'
  /** V2021_1 プレミアムプラン */
  | 'V2021_1Premium'
  /** V2021_1 スタンダードプラン */
  | 'V2021_1Standard'
  /** V2022_1 Enterpriseプラン */
  | 'V2022_1Enterprise'
  /** V2022_1 Entryプラン */
  | 'V2022_1Entry'
  /** V2022_1 PRプラン */
  | 'V2022_1PR'
  /** V2022_1 Proプラン */
  | 'V2022_1Pro'
  /** V2022_2 管理者専用無料プラン */
  | 'V2022_2ManageOnlyFree'
  /** V2023_1 エンタープライズプラン */
  | 'V2023_1Enterprise'
  /** V2023_1 エキスパートプラン */
  | 'V2023_1Expert'
  /** V2023_1 管理者専用無料プラン */
  | 'V2023_1ManageOnlyFree'
  /** V2023_1 マスタープラン */
  | 'V2023_1Master'
  /** V2023_1 スキルフォースプラン */
  | 'V2023_1SkillForce';

export type Prefecture =
  | 'Aichi'
  | 'Akita'
  | 'Aomori'
  | 'Chiba'
  | 'Ehime'
  | 'Fukui'
  | 'Fukuoka'
  | 'Fukushima'
  | 'Gifu'
  | 'Gunma'
  | 'Hiroshima'
  | 'Hokkaido'
  | 'Hyogo'
  | 'Ibaraki'
  | 'Ishikawa'
  | 'Iwate'
  | 'Kagawa'
  | 'Kagoshima'
  | 'Kanagawa'
  | 'Kochi'
  | 'Kumamoto'
  | 'Kyoto'
  | 'Mie'
  | 'Miyagi'
  | 'Miyazaki'
  | 'Nagano'
  | 'Nagasaki'
  | 'Nara'
  | 'Niigata'
  | 'Oita'
  | 'Okayama'
  | 'Okinawa'
  | 'Osaka'
  | 'Saga'
  | 'Saitama'
  | 'Shiga'
  | 'Shimane'
  | 'Shizuoka'
  | 'Tochigi'
  | 'Tokushima'
  | 'Tokyo'
  | 'Tottori'
  | 'Toyama'
  | 'Wakayama'
  | 'Yamagata'
  | 'Yamaguchi'
  | 'Yamanashi';

export type UserGender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type FetchKarteUserDetailViewQueryVariables = Exact<{
  id: string | number;
}>;


export type FetchKarteUserDetailViewQuery = { karte: { kartePlannerCommentAvailability: { availability: boolean, unavailableReason: Types.KartePlannerCommentUnavailableReason | null }, ownKartePlannerComment: { comment: string | null, selections: Array<string> | null } | null, user: { livingPrefecture: Types.Prefecture | null, birthYear: number | null, gender: Types.UserGender, numberOfMatch: number, address: { prefecture: string, city: string } | null } }, viewer: { plan: Types.Plan } };

export type PostKartePlannerCommentMutationVariables = Exact<{
  karteID: string | number;
  comment: string;
  selections?: Array<string> | string | null | undefined;
}>;


export type PostKartePlannerCommentMutation = { postKartePlannerComment:
    | { __typename: 'PostKartePlannerCommentMutationErrorPayload', error: Types.KartePlannerCommentUnavailableReason }
    | { __typename: 'PostKartePlannerCommentMutationSuccessPayload', karte: { id: string, numberOfPlannerComments: number, isLikelyToMatch: boolean, hasCommentsFromPlannersBelongingToSameBranch: boolean, kartePlannerCommentAvailability: { availability: boolean, unavailableReason: Types.KartePlannerCommentUnavailableReason | null }, ownKartePlannerComment: { id: string, comment: string | null, selections: Array<string> | null } | null }, viewer: { id: string, kartePlannerCommentMonthlyAmount:
          | { __typename: 'ManageOnlyFreePlanKartePlannerCommentMonthlyAmount' }
          | { __typename: 'V2021_1KartePlannerCommentMonthlyAmount', items: Array<{ channel: Types.Channel, usage: number, upperLimit: number | null }> }
          | { __typename: 'V2022_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit: number | null }
          | { __typename: 'V2023_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit: number | null }
         } }
   };


export const FetchKarteUserDetailViewDocument = gql`
    query FetchKarteUserDetailView($id: ID!) {
  karte(id: $id) {
    kartePlannerCommentAvailability {
      ...KartePlannerCommentFormAvailability
    }
    ownKartePlannerComment {
      comment
      selections
    }
    user {
      livingPrefecture
      birthYear
      gender
      address {
        prefecture
        city
      }
      numberOfMatch
    }
  }
  viewer {
    ...KartePlannerCommentFormViewer
  }
}
    ${KartePlannerCommentFormAvailabilityFragmentDoc}
${KartePlannerCommentFormViewerFragmentDoc}`;

/**
 * __useFetchKarteUserDetailViewQuery__
 *
 * To run a query within a Vue component, call `useFetchKarteUserDetailViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchKarteUserDetailViewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchKarteUserDetailViewQuery({
 *   id: // value for 'id'
 * });
 */
export function useFetchKarteUserDetailViewQuery(variables: FetchKarteUserDetailViewQueryVariables | VueCompositionApi.Ref<FetchKarteUserDetailViewQueryVariables> | ReactiveFunction<FetchKarteUserDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>(FetchKarteUserDetailViewDocument, variables, options);
}
export function useFetchKarteUserDetailViewLazyQuery(variables?: FetchKarteUserDetailViewQueryVariables | VueCompositionApi.Ref<FetchKarteUserDetailViewQueryVariables> | ReactiveFunction<FetchKarteUserDetailViewQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>(FetchKarteUserDetailViewDocument, variables, options);
}
export type FetchKarteUserDetailViewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchKarteUserDetailViewQuery, FetchKarteUserDetailViewQueryVariables>;
export const PostKartePlannerCommentDocument = gql`
    mutation postKartePlannerComment($karteID: ID!, $comment: String!, $selections: [String!]) {
  postKartePlannerComment(
    karteID: $karteID
    comment: $comment
    selections: $selections
  ) {
    __typename
    ... on PostKartePlannerCommentMutationErrorPayload {
      error
    }
    ... on PostKartePlannerCommentMutationSuccessPayload {
      karte {
        id
        kartePlannerCommentAvailability {
          ...KartePlannerCommentFormAvailability
        }
        ownKartePlannerComment {
          id
          comment
          selections
        }
        numberOfPlannerComments
        isLikelyToMatch
        hasCommentsFromPlannersBelongingToSameBranch
      }
      viewer {
        id
        kartePlannerCommentMonthlyAmount {
          ...KartePlannerCommentMonthlyAmount
        }
      }
    }
  }
}
    ${KartePlannerCommentFormAvailabilityFragmentDoc}
${KartePlannerCommentMonthlyAmountFragmentDoc}`;

/**
 * __usePostKartePlannerCommentMutation__
 *
 * To run a mutation, you first call `usePostKartePlannerCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePostKartePlannerCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePostKartePlannerCommentMutation({
 *   variables: {
 *     karteID: // value for 'karteID'
 *     comment: // value for 'comment'
 *     selections: // value for 'selections'
 *   },
 * });
 */
export function usePostKartePlannerCommentMutation(options: VueApolloComposable.UseMutationOptions<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables>(PostKartePlannerCommentDocument, options);
}
export type PostKartePlannerCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PostKartePlannerCommentMutation, PostKartePlannerCommentMutationVariables>;